import { useId } from "react";
import { ProductPricePreferenceCheckboxGroup } from "@/components/admin/UserTable/PricePreference/ProductPricePreferenceCheckboxGroup";
import {
  PRODUCT_CONFIGS_FOR_ESTIMATED_PRICE_UPDATE,
  type ProductConfigForEstimatedPriceUpdate,
} from "@/components/admin/UserTable/PricePreference/schema";

interface PriceUpdatePreferenceFormProps {
  index: number;
  disabled?: boolean;
}

export interface CheckboxGroupProps {
  title: string;
  basePath: string;
  products: ProductConfigForEstimatedPriceUpdate["products"];
  contracts: ProductConfigForEstimatedPriceUpdate["contracts"];
  disabled?: boolean;
  showLongHorizonSwitch?: boolean;
}

export function PriceUpdatePreferenceForm({ disabled }: PriceUpdatePreferenceFormProps) {
  return (
    <div className="space-y-6" key={useId()}>
      {Object.entries(PRODUCT_CONFIGS_FOR_ESTIMATED_PRICE_UPDATE).map(([key, config]) => (
        <ProductPricePreferenceCheckboxGroup
          key={key}
          title={config.title}
          basePath={`estimated_price_update_preferences.${config.path}`}
          products={config.products}
          contracts={config.contracts}
          disabled={disabled}
          showLongHorizonSwitch={config.path === "sparkspread"}
        />
      ))}
    </div>
  );
}
